var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"app":"","color":"grey lighten-5"}},[_c('v-container',{staticClass:"d-flex align-center",staticStyle:{"max-width":"960px"}},[_c('v-img',{attrs:{"data-cy":"logo","src":"/traderfox.png","max-width":"140"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }